(function (TIPTOE, window, document, $) {
  const hotspots = document.querySelectorAll('.js-modal-origin');

  const string = window.location.href;
  const substring = 'lookbook';

  const eventAction = string.includes(substring) ? 'Clic_Hotspot' : 'Découvrir_Création';
  const eventLabel = string.includes(substring) ? 'Clic_Hotspot_Lookbook' : 'Découvrir_Création';
  const eventActionModal = 'Découvrir_Produit_Lightbox';
  const eventLabelModal = string.includes(substring)
    ? 'Clic_Bouton_Découvrir_Lookbook'
    : 'Clic_Bouton_Découvrir_Vos_Creations';

  /**
   * Handle an hotspot click and open a modal with the given information
   */
  function handleHotspostClick(e) {
    // Do not open modal if share__link is clicked
    if ($(e.target).hasClass('pagination__link')) {
      return;
    }

    const heightPercent = Math.floor((e.clientY * 100) / window.innerHeight);
    const widthPercent = Math.floor((e.clientX * 100) / window.innerWidth);
    const targetElement = $(e.target).closest('.js-modal-origin').get(0);
    const { title } = targetElement.dataset;
    const { url } = targetElement.dataset;
    const linkText = targetElement.dataset.link;
    const description = targetElement.dataset.description || '';
    const size = targetElement.dataset.size || '';
    const price = targetElement.dataset.price || null;
    const pricelabel = targetElement.dataset.pricelabel || '';
    const titleurl = targetElement.dataset.titleurl || '';
    const thumb = targetElement.dataset.thumb || '';
    const svg =
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12"><polygon points="6 6.6 1.3,11.3 0.7,10.7 5.4,6 0.7,1.3 1.3,0.7 6,5.4 10.7,0.7 11.3,1.3 6.6,6 11.3,10.7 10.7,11.3 	"/><polygon points="10.7,0 6,4.7 1.3,0 0,1.3 4.7,6 0,10.7 1.3,12 6,7.3 10.7,12 12,10.7 7.3,6 12,1.3 10.7,0 "/></svg>';

    // If no title is provided, do nothing
    if (!title) return null;

    /** Remove existing modal */
    const prevModal = document.querySelector('.hotspot-image__modal__container');
    if (prevModal) {
      prevModal.remove();
    }

    // only in creations pages
    const shareTemplate = window.location.href.includes('creations')
      ? `<div class="modal__share">` +
        `<a id="fb-share" class="pagination__link share__link" href="http://www.facebook.com/share.php?u=${url}&title=${title}"` +
        `onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">` +
        `<svg width="52px" height="52px" viewbox="0 0 52 52">` +
        `<path d="M22.1,35.1h4.5V24.5h3c0,0,0.3-1.7,0.4-3.6h-3.4v-2.4c0-0.4,0.5-0.9,1-0.9h2.5v-3.7h-3.4c-4.8,0-4.6,3.6-4.6,4.1v2.9h-2.2 v3.6h2.2V35.1z"/>` +
        `<rect class="pagination__hover" x="0" y="0" width="52" height="52"/>` +
        `</svg>` +
        `</a>` +
        `<a id="pin-share"` +
        `class="pagination__link share__link"` +
        `onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"` +
        `data-pin-do="buttonPin" data-pin-custom="true" data-pin-count="beside" data-pin-save="false"` +
        `data-pin-href='https://www.pinterest.com/pin/create/button/?url=${url}&media=${thumb}&description=TIPTOE - ${description}'` +
        `href='https://www.pinterest.com/pin/create/button/?url=${url}&media=${thumb}&description=TIPTOE - ${description}'>` +
        `<svg width="52px" height="52px" viewbox="0 0 52 52">` +
        `<path d="M17.7,25.7c0.3,0.1,0.6,0,0.7-0.3c0.1-0.2,0.2-0.8,0.3-1c0.1-0.3,0.1-0.4-0.2-0.7c-0.5-0.6-0.9-1.4-0.9-2.5 c0-3.2,2.5-6.1,6.6-6.1c3.6,0,5.6,2.1,5.6,4.8c0,3.6-1.7,6.7-4.2,6.7c-1.4,0-2.4-1.1-2.1-2.4c0.4-1.6,1.2-3.3,1.2-4.5 c0-1-0.6-1.9-1.8-1.9c-1.4,0-2.6,1.4-2.6,3.3c0,1.2,0.4,2,0.4,2s-1.5,5.9-1.7,6.9c-0.5,2-0.1,4.5,0,4.8c0,0.1,0.2,0.2,0.3,0.1` +
        `c0.1-0.2,1.8-2.1,2.4-4.1c0.2-0.6,0.9-3.5,0.9-3.5c0.5,0.8,1.8,1.6,3.3,1.6c4.3,0,7.2-3.7,7.2-8.7c0-3.7-3.4-7.2-8.5-7.2 c-6.4,0-9.6,4.3-9.6,7.9C15,23.1,15.9,25,17.7,25.7z"/>` +
        `<rect class="pagination__hover" x="0" y="0" width="52" height="52"/>` +
        `</svg>` +
        `</a>` +
        `</div>`
      : '';

    /** Modal template */
    const modalTemplate =
      `<div class="hotspot-image__modal__container" id="hotspot-modal">` +
      `<div class="hotspot-image__modal ${
        thumb ? '' : 'text-only'
      }" style="transform-origin: ${widthPercent}%  ${heightPercent}%">${
        thumb
          ? `<div class="hotspot-image__modal__side--left"><div style="background-image:url(${thumb})"></div></div>`
          : ''
      }<div class="hotspot-image__modal__side--right">` +
      `<div>` +
      `<div class="hotspot-image__modal__content">${
        titleurl ? `<a href="${titleurl}" target="_blank">` : ''
      }<div class="t-largest t-medium">` +
      `<p class="hotspot-image__modal__title">${title}</p>` +
      `</div>${titleurl ? '</a>' : ''}<div class="t-upper hotspot-image__modal__label t-bold">` +
      `<p>${description}&nbsp;&#8226;&nbsp;${size}</p>` +
      `</div>${
        price && price.length
          ? `<p class="hotspot-image__modal__price">${price}€<sup>${pricelabel}</sup></p>`
          : ''
      }</div>` +
      `<div class="modal__discover">${
        url
          ? `<a class="btn btn--black js-modal-event" href="${url}"><span class="btn__label">${linkText}</span></a>`
          : ''
      }${shareTemplate}</div>` +
      `</div>` +
      `</div>` +
      `<div class="hotspot-image__modal__close-btn">${svg}</div>` +
      `</div>` +
      `</div>`;

    // Show the modal
    $('body').append(modalTemplate);

    // Stop scroll propagation to prevent body scroll
    $('#hotspot-modal, .hotspot-image__modal').on(
      'DOMMouseScroll mousewheel scroll touchmove',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
    );

    setTimeout(function () {
      document.querySelector('#hotspot-modal').className += ' is-active';
    }, 200);

    $('#fb-share').on('click', function () {
      if (typeof ga === 'function') {
        ga('send', 'event', 'Partage', 'Partage_Creation', 'Partage_Creation_Modal_Facebook');
      }
    });

    $('#pin-share').on('click', function () {
      if (typeof ga === 'function') {
        ga('send', 'event', 'Partage', 'Partage_Creation', 'Partage_Creation_Modal_Pinterest');
      }
    });

    /** Add an eventListener to close an opened modal by clicking on its backdrop or on the close button */
    document
      .querySelector('.hotspot-image__modal__container')
      .addEventListener('click', function () {
        document
          .querySelector('#hotspot-modal')
          .parentNode.removeChild(document.querySelector('#hotspot-modal'));
      });

    /** Prevent click on the modal content */
    document.querySelector('.hotspot-image__modal').addEventListener('click', function (e) {
      if (!e.target.className.includes('btn') && e.target.nodeName !== 'H2') {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    for (const hotspot of hotspots) {
      hotspot.addEventListener('click', handleHotspostClick);
    }

    ga('send', 'event', 'Découvrir', eventAction, eventLabel);

    $(document).on('click', '.js-modal-event', function (e) {
      // abandon if link already aborted or analytics is not available
      if (typeof ga !== 'function') return;
      eventAnalytics(e);
    });

    /**
     *
     */
    function eventAnalytics(e) {
      ga('send', 'event', 'Découvrir', eventActionModal, eventLabelModal);
    }
  }

  /**
   * Main entry, create an even listener for each hotspot button
   * on the page
   * @type {NodeList}
   */
  for (const hotspot of hotspots) {
    hotspot.addEventListener('click', handleHotspostClick);
  }

  window.addEventListener('ajaxEnd', init, false);

  /**
   *
   */
  function init() {
    const hotspots = document.querySelectorAll('.js-modal-origin');
    for (const hotspot of hotspots) {
      hotspot.addEventListener('click', handleHotspostClick);
    }
  }
})(TIPTOE, window, document, jQuery);
